import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { subjectFromObs } from 'core/rx-js';
import { LoaderService } from 'core/services';
import { BehaviorSubject, combineLatest, distinctUntilChanged, filter, map, Subject, switchMap } from 'rxjs';

@Component({
  selector: 'ss-core-loader-outlet',

  templateUrl: './loader-outlet.component.html',
  styleUrls: ['./loader-outlet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderOutletComponent {
  readonly #destroy = new Subject<void>()
  private _height: string = '15rem'
  @Input() get height() {
    return this._height
  }

  set height(value) {
    this._height = value;
  }




  readonly keySubject = new BehaviorSubject<string[]>(undefined)
  @Input() get keys() {
    return this.keySubject.value;
  }
  set keys(value) {
    this.keySubject.next(value)
  }

  readonly diameterSubject = new BehaviorSubject<number>(50);
  @Input() get diameter() {
    return this.diameterSubject.value;
  }
  set diameter(value) {
    this.diameterSubject.next(value)
  }

  readonly strokeWidthObs = this.diameterSubject.pipe(map(diameter => diameter / 10))
  readonly loadersSubject = subjectFromObs({
    observable: combineLatest([
      this.keySubject.pipe(filter(Boolean)),
      this._loaderService.loadersSubject
    ])
      .pipe(
        map(([keys, loaders]) => Object.values(loaders).filter(({ key: searchKey }) => keys.includes(searchKey)))
      ),
    initialValue: [],
    until: this.#destroy
  })

  readonly spinnerStyleObs = this.diameterSubject.pipe(
    map((diameter) => ({
      left: `calc(50% - ${diameter / 10 / 2}rem)`,
      top: `calc(50% - ${diameter / 10 / 2}rem)`
    }))
  )
  readonly showLoadersSubject = subjectFromObs({
    observable: this.loadersSubject.pipe(
      map(loaders => Boolean(loaders.length)), distinctUntilChanged()
    ),
    initialValue: false,
    until: this.#destroy
  })


  readonly displayObs = this.loadersSubject.pipe(
    map((loaders) => loaders
      .filter(loader => loader.text)
      .map((loader) => loader.text)
    ),
    filter((textKeys) => Boolean(textKeys.length)),
    switchMap((textKeys) => this._translateService.get(textKeys)),
    map((translations) => Object.values(translations))
  )

  constructor(
    private readonly _loaderService: LoaderService,
    private readonly _translateService: TranslateService,
  ) {

  }

  ngAfterViewInit() {
  }



  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
} 
